export class SearchEntitlements {
    username = "";
    authToken = "";
    searchtext = "";
    searchtype = "entitlement"; // entitlement, license, usb
	licensetype = "permanent"; // permanent, temporary
}

export class AdminSearchResults {
    tenasysentitlementid = "";
	createddate?: Date;
	enddate?: Date;
	daystolive?: number;
	createdby = "";
	internalcomment = "";
	license = "";
	activateddate?: Date;
	activatedby = "";
	ponumber = "";
	customeractivationcomment = "";
	ipaddress = "";
	fingerprint = "";
	usbkey = "";
	source = "";
	suac = "";
	classiclicense = "";
    classicordernumber = "";
    classicinvoicenumber = "";
    modifieddate?: Date;
    modifiedby = "";
	modifiedcomment = "";
	crmaccountid = "";
	crminvoicename = "";
	shortlicense = "";
	productname = "";
	createbatchid = 0;
	licenseidentifer?: string = "";
	// fb19507: reservation_types.type for the entitlement (e.g. Available, Deleted); may be null.
	reservation_type = "";
}